/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1NotificationMobileApp200,
  GetApiV1NotificationMobileApp401,
  GetApiV1NotificationMobileApp500,
  GetApiV1NotificationMobileAppQueryParams,
  GetApiV1NotificationMobileAppQueryResponse,
} from "../../types/notificationMobileAppController/GetApiV1NotificationMobileApp.ts";
import { eMobileNotificationStatusSchema } from "../eMobileNotificationStatusSchema.ts";
import { mobileNotificationGridItemViewModelSchema } from "../mobileNotificationGridItemViewModelSchema.ts";

export const getApiV1NotificationMobileAppQueryParamsSchema = z
  .object({
    PageNumber: z.optional(
      z.coerce.number().int().describe("Número da página. Mínimo 1."),
    ),
    PageSize: z.optional(
      z.coerce.number().int().describe("Quantidade de registros por página."),
    ),
    SearchText: z.optional(
      z
        .string()
        .describe(
          "Filtro textual aplicado sobre o título da notificação. Opcional.",
        ),
    ),
    ClassStudentIds: z.optional(
      z
        .array(z.coerce.number().int())
        .describe(
          "Filtra notificações que contenham ao menos uma das turmas informadas. Opcional.",
        ),
    ),
    StatusNotification: z.optional(
      z
        .array(
          z
            .lazy(() => eMobileNotificationStatusSchema)
            .describe(
              "1 = Draft | 2 = Scheduled | 3 = Processing | 4 = Completed | 5 = Canceled | ",
            ),
        )
        .describe(
          "Filtra por um ou mais status de notificação. Opcional. Enum EMobileNotificationStatus: `1` = Draft, `2` = Scheduled, `3` = Processing, `4` = Completed, `5` = Canceled.",
        ),
    ),
    CreatedById: z.optional(
      z.coerce
        .number()
        .int()
        .describe(
          "Filtra notificações criadas pelo usuário com este ID. Opcional.",
        ),
    ),
    StartDate: z.optional(
      z
        .string()
        .datetime()
        .describe(
          "Data inicial do intervalo de envio/agendamento (inclusivo). Opcional.",
        ),
    ),
    EndDate: z.optional(
      z
        .string()
        .datetime()
        .describe(
          "Data final do intervalo de envio/agendamento (inclusivo). Opcional.",
        ),
    ),
  })
  .optional() as unknown as ToZod<GetApiV1NotificationMobileAppQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1NotificationMobileApp200Schema = z.array(
  z.lazy(() => mobileNotificationGridItemViewModelSchema),
) as unknown as ToZod<GetApiV1NotificationMobileApp200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1NotificationMobileApp401Schema =
  z.any() as unknown as ToZod<GetApiV1NotificationMobileApp401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1NotificationMobileApp500Schema =
  z.any() as unknown as ToZod<GetApiV1NotificationMobileApp500>;

export const getApiV1NotificationMobileAppQueryResponseSchema = z.lazy(
  () => getApiV1NotificationMobileApp200Schema,
) as unknown as ToZod<GetApiV1NotificationMobileAppQueryResponse>;
